import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Y si no creo en esto?',
  a: 'No necesitas creer. Necesitas seguir las instrucciones. El ritual trabaja con intención, no con fe ciega. Muchos de los testimonios vienen de personas que empezaron escépticas.'
}, {
  q: '¿Funciona aunque hayan pasado meses de la separación?',
  a: 'Sí. El tiempo no debilita el cordón energético entre dos personas que estuvieron unidas. Solo lo estira. Los ancestros llamaban a esto "la memoria del hilo" — mientras más tiempo, más tensión acumulada para el retorno.'
}, {
  q: '¿Qué pasa si me salto una noche?',
  a: 'El módulo 19 del manual responde esto exactamente. El ritual contempla ese escenario con instrucciones precisas.'
}, {
  q: '¿Tiene consecuencias negativas o karma?',
  a: 'No. Este es un retorno de derecho propio, no un trabajo de control. Los ancestros distinguían claramente entre reclamar lo que es tuyo y forzar la voluntad de otro. Esto es lo primero.'
}, {
  q: '¿Funciona si ya hay un tercero involucrado?',
  a: 'Sí. El módulo 4 del manual trata específicamente la interferencia externa. La energía de un tercero no puede competir con el cordón original que te une a la persona amada.'
}, {
  q: 'Ya gasté mucho dinero en brujos. ¿Por qué esto sería diferente?',
  a: 'Ese dinero ya no regresa. Pero el tiempo que te queda sí puede usarse mejor. La diferencia es quién hace el ritual: un extraño sin conexión, o tú. Por eso decidí que este manual costara $12 — sin excusas posibles.'
}];
const FaqItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/10 last:border-0" data-id="element-126">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none" aria-expanded={isOpen} data-id="element-127">
        <span className="text-lg font-bold text-white pr-8" data-id="element-128">{q}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="text-gold shrink-0" data-id="element-129">
          <ChevronDown size={24} data-id="element-130" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-131">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-132">
            <p className="pb-6 text-text-secondary leading-relaxed" data-id="element-133">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FaqFooterSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-134">
      {/* BLOQUE 16: FAQ */}
      <section className="py-20 px-4 bg-mystic-800/20 border-t border-gold/10" data-id="element-135">
        <div className="max-w-3xl mx-auto" data-id="element-136">
          <FadeIn data-id="element-137">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-138">
              Respuestas a lo que probablemente te estás preguntando
            </h2>

            <div className="glass-panel rounded-xl px-6 md:px-8" data-id="element-139">
              {faqs.map((faq, idx) => <FaqItem key={idx} q={faq.q} a={faq.a} data-id="element-140" />)}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BLOQUE 17: AVISO LEGAL */}
      <footer className="py-12 px-4 bg-black border-t border-white/5" data-id="element-141">
        <div className="max-w-4xl mx-auto text-center" data-id="element-142">
          <p className="text-xs text-text-secondary/60 leading-relaxed mb-4" data-id="element-143">
            Este producto se ofrece exclusivamente con fines de entretenimiento,
            exploración espiritual y desarrollo personal. Los resultados pueden
            variar según la intención, la energía y el libre albedrío de cada
            individuo. El autor no garantiza resultados específicos. Al realizar
            la compra, el usuario acepta los términos y condiciones del
            servicio. Queda prohibida la reproducción total o parcial de este
            material.
          </p>
          <p className="text-xs text-gold/50" data-id="element-144">
            © Amarre Ancestral de 3 Noches — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
};